<template>
  <VueTelegramLogin
    mode="callback"
    :telegram-login="config.TELEGRAM_BOT"
    @callback="onTelegramAuth"
  />
</template>
<script>
  import { vueTelegramLogin } from 'vue-telegram-login'
  import { config } from "@/core/config"

  export default {
    name: "TelegramSignInButton",
    components: {
      VueTelegramLogin : vueTelegramLogin
    },
    data() {
      return {
        config
      }
    },
    methods: {
      onTelegramAuth(user) {
        this.$emit("input", user)
      }
    }
  }
</script>
